import ReactGA from 'react-ga4'
import ReactPixel from 'react-facebook-pixel'
import { Enum } from '../../data/types/constants'

type EventParams = {
  reference_number?: number
  credit_application_id?: string
  amount?: number
}

const createEvent = (eventName: string) => (params: EventParams) => {
  const eventID = `${eventName}-${params.reference_number}`
  ReactPixel.fbq('trackCustom', eventName, params, { eventID })
  ReactGA.event(eventName, { ...params, transaction_id: eventID })
}

const trackingEvents = {
  getStarted: createEvent(Enum.ETrackingEvents.GetStarted),
  prequalSuccess: createEvent(Enum.ETrackingEvents.PrequalSuccess),
  prequalDeclined: createEvent(Enum.ETrackingEvents.PrequalDeclined),
  qualifSuccess: createEvent(Enum.ETrackingEvents.QualifSuccess),
  qualifDeclined: createEvent(Enum.ETrackingEvents.QualifDeclined),
  withdrewAfterPrequal: createEvent(Enum.ETrackingEvents.WithdrewAfterPrequal),
  withdrewAfterQualif: createEvent(Enum.ETrackingEvents.WithdrewAfterQualif),
  withdrewManualRevision: createEvent(Enum.ETrackingEvents.WithdrewManualRevision),
}

export { trackingEvents }
